import { render, staticRenderFns } from "./WishlistButton.vue?vue&type=template&id=81f7f866&scoped=true"
import script from "./WishlistButton.vue?vue&type=script&lang=js"
export * from "./WishlistButton.vue?vue&type=script&lang=js"
import style0 from "./WishlistButton.vue?vue&type=style&index=0&id=81f7f866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f7f866",
  null
  
)

export default component.exports